import { createPlugin } from '@backstage/core-plugin-api';
import { catalogGraphRouteRef, catalogEntityRouteRef } from './routes.esm.js';

const catalogGraphPlugin = createPlugin({
  id: "catalog-graph",
  routes: {
    catalogGraph: catalogGraphRouteRef
  },
  externalRoutes: {
    catalogEntity: catalogEntityRouteRef
  }
});

export { catalogGraphPlugin };
//# sourceMappingURL=plugin.esm.js.map
